var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRpgGames = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Video-Game-Knight--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Video Game Knight Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 13H22a0.5 0.5 0 0 1 -0.5 -0.5v-9c0 -0.83 -0.67 -3.5 -1.5 -3.5s-1.5 2.67 -1.5 3.5v9a0.5 0.5 0 0 1 -0.5 0.5h-1.5a0.5 0.5 0 0 0 0 1h7a0.5 0.5 0 0 0 0 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.5h-1a0.5 0.5 0 0 0 -0.5 0.5v3.5a1 1 0 0 0 2 0V16a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13.9a0.48 0.48 0 0 1 -0.21 -0.34 0.54 0.54 0 0 1 0.1 -0.39 5.05 5.05 0 0 0 1 -2 1.17 1.17 0 0 1 0.22 -0.48l2.35 -3.09a1.25 1.25 0 0 0 0 -1.41 1.23 1.23 0 0 0 -1.16 -0.56h-1.36a0.51 0.51 0 0 1 -0.5 -0.45 5.54 5.54 0 0 0 -3.34 -5 3.81 3.81 0 0 0 -2.66 0 18.31 18.31 0 0 0 -4.22 2c-0.5 0.29 -1 0.57 -1.45 0.82A0.5 0.5 0 0 0 2 4h2.21a0.48 0.48 0 0 1 0.39 0.18 0.47 0.47 0 0 1 0.1 0.41c0 0.2 -0.07 0.41 -0.1 0.64a0.51 0.51 0 0 1 -0.5 0.43H2.69a1.24 1.24 0 0 0 -1.11 2l1.14 1.5a1 1 0 0 0 0.79 0.4h1a0.5 0.5 0 0 0 0.4 -0.8l-0.51 -0.7a0.25 0.25 0 0 1 0 -0.26 0.24 0.24 0 0 1 0.23 -0.14h8.81a0.24 0.24 0 0 1 0.22 0.14 0.25 0.25 0 0 1 0 0.26l-1.49 1.88a1.06 1.06 0 0 0 -0.19 0.48 3 3 0 0 1 -1.27 2.09 0.51 0.51 0 0 0 -0.21 0.41v4.63c0 2.08 -1.47 4.5 -3.12 6a0.23 0.23 0 0 0 -0.06 0.27 0.24 0.24 0 0 0 0.23 0.16H15a1 1 0 0 0 1 -1v-2.65a7.57 7.57 0 0 0 -3 -6.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.05a1 1 0 0 0 -1 -1H1a1 1 0 0 0 -1 1v5.5c0 2.73 3.23 6 4.5 6s4.5 -3.27 4.5 -6ZM6.5 16.3h-0.75a0.5 0.5 0 0 0 -0.5 0.5v2.25a0.75 0.75 0 0 1 -1.5 0V16.8a0.5 0.5 0 0 0 -0.5 -0.5H2.5a0.75 0.75 0 0 1 0 -1.5h0.75a0.5 0.5 0 0 0 0.5 -0.5v-0.75a0.75 0.75 0 0 1 1.5 0v0.75a0.5 0.5 0 0 0 0.5 0.5h0.75a0.75 0.75 0 0 1 0 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.3a0.75 0.75 0 1 0 1.5 0 0.75 0.75 0 1 0 -1.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.3a0.75 0.75 0 1 0 1.5 0 0.75 0.75 0 1 0 -1.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRpgGames);
export default ForwardRef;